export default __webpack_public_path__ + "eb61572490d4259ff3dab9458d1f99de.svg";